var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAndBrandingPenTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "540.5,153.1 327.5,574.2 440.2,711.7 454.4,747.9 455.7,917.9 625.3,917.9 629.3,736.1 747.8,571.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.5,153.1L333.2,571.2l103.1,134.9c12.6,16.4,19.4,36.6,19.4,57.2v154.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.5,153.1l207.3,418.3L644.7,706.3c-12.6,16.3-19.4,36.5-19.4,57.1V918"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 540.5,
    y1: 122.9,
    x2: 540.5,
    y2: 578.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -176.7603 250.1796)",
    cx: 540.5,
    cy: 569.4,
    rx: 34.4,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 401.1,
    y1: 823.8,
    x2: 678.1,
    y2: 823.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.8,
    y: 823.8,
    width: 120.5,
    height: 94.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndBrandingPenTool);
export default __webpack_public_path__ + "static/media/Logo-and-Branding-Pen-Tool.f8b70d992a6b94184272748bdf402984.svg";
export { ForwardRef as ReactComponent };